import { processingStatus } from '../../constants/enum';

/**
 * OCR結果一覧のタブ状態をURLで受け渡すためのユーティリティ
 *
 * ファイル出力履歴などへ遷移したあと、戻ったときに元のタブを表示するために使う。
 * URLで保持するため、リロードやブラウザバックでもタブが維持される。
 */

/** URLクエリでタブを指定するキー */
export const RESULT_TAB_PARAM_KEY = 'tab';

/** OCR結果一覧のタブとして有効なステータス */
const RESULT_TAB_STATUSES: number[] = [
  processingStatus.processing,
  processingStatus.completed,
  processingStatus.outputted,
];

/**
 * URLクエリのタブ指定を有効なステータス値へ解決する
 * 未指定・不正値のときは既定の「未処理」を返す
 */
export const parseResultTabParam = (value: string | null): number => {
  const parsed = Number(value);
  return RESULT_TAB_STATUSES.includes(parsed) ? parsed : processingStatus.processing;
};

/**
 * タブ状態を引き継ぐためのクエリ文字列を作る（例: '?tab=3'）
 * 既定の「未処理」や不正値のときは空文字を返し、URLを不要に長くしない
 */
export const buildResultTabQuery = (tab: number): string =>
  RESULT_TAB_STATUSES.includes(tab) && tab !== processingStatus.processing
    ? `?${RESULT_TAB_PARAM_KEY}=${tab}`
    : '';
